import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import type { Product } from '../../types/catalog';
import { ProductTags } from './ProductTags';
export function ProductGallery({
  product
}: {
  product: Product;
}) {
  const [active, setActive] = useState(0);
  const [zoom, setZoom] = useState(false);
  const [origin, setOrigin] = useState('50% 50%');
  const count = product.images.length;
  const go = (dir: 1 | -1) => setActive(a => (a + dir + count) % count);
  const onMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = (e.clientX - rect.left) / rect.width * 100;
    const y = (e.clientY - rect.top) / rect.height * 100;
    setOrigin(`${x}% ${y}%`);
  };
  return <div className="grid gap-3 md:grid-cols-[76px_1fr] md:gap-4" data-id="element-551" data-mp="3jvotawh7ov3j">
      <ul className="order-2 flex gap-2 md:order-1 md:flex-col" aria-label="Miniatures" data-id="element-552" data-mp="3nvh65ldn1nep">
        {product.images.map((src, i) => <li key={src + i} data-id="element-553" data-mp="16skj0i5vh0yv" data-mpi={i}>
            <button type="button" onClick={() => setActive(i)} aria-label={`Voir l’image ${i + 1}`} aria-current={active === i} className={`block h-20 w-16 overflow-hidden rounded-sm transition-[opacity,box-shadow] duration-150 md:h-24 md:w-[76px] ${active === i ? 'opacity-100 ring-1 ring-ink ring-offset-2 ring-offset-paper' : 'opacity-60 hover:opacity-100'}`} data-id="element-554" data-mp="11vaia6d192vq">
              <img src={src} alt="" className="h-full w-full object-cover" data-id="element-555" data-mp="iyj6ehztlq1p" />
            </button>
          </li>)}
      </ul>
      <div className="relative order-1 aspect-[4/5] cursor-zoom-in overflow-hidden rounded-sm bg-shell md:order-2" onMouseEnter={() => setZoom(true)} onMouseLeave={() => setZoom(false)} onMouseMove={onMove} data-id="element-556" data-mp="suvyjbfpvvuc">
        <AnimatePresence initial={false} data-id="element-557" data-mp="2499iw6b9ht5m">
          <motion.img key={active} src={product.images[active]} alt={active === 0 ? product.name : `${product.name}, vue ${active + 1}`} initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} transition={{
          duration: 0.25
        }} style={{
          transformOrigin: origin
        }} className={`absolute inset-0 h-full w-full object-cover transition-transform duration-200 ease-out ${zoom ? 'md:scale-[1.6]' : 'scale-100'}`} data-id="element-558" data-mp="2bd7ujz8jpv13" />
        </AnimatePresence>
        <ProductTags product={product} data-id="element-559" data-mp="22knucuclvie5" />
        {count > 1 && <div className="absolute bottom-3 right-3 flex gap-2 md:hidden" data-id="element-560" data-mp="22jcnumrrzwjc">
            <button type="button" onClick={() => go(-1)} aria-label="Image précédente" className="flex h-9 w-9 items-center justify-center rounded-full bg-paper/90" data-id="element-561" data-mp="27c5trdyzdax0">
              <ChevronLeftIcon className="h-4 w-4" data-id="element-562" data-mp="1eutdm1p619om" />
            </button>
            <button type="button" onClick={() => go(1)} aria-label="Image suivante" className="flex h-9 w-9 items-center justify-center rounded-full bg-paper/90" data-id="element-563" data-mp="1esqfsvhruc9c">
              <ChevronRightIcon className="h-4 w-4" data-id="element-564" data-mp="3o52ktw0wvtla" />
            </button>
          </div>}
      </div>
    </div>;
}